import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type { CoachingSession } from '@efdigital/ll-addon-data';
import { queryCoachingSessionsByCoach } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-sessions';
import type { CoachingCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach';
import type CoachActionRequiredService from '@efdigital/ll-xceed-v2/services/coach-action-required';
import {
  COACH_ACTION_REQUIRED_QUERY_KEYS,
  COACH_PENDING_CONFIRMATION_KEYS,
  filterCoachActionRequired,
} from '@efdigital/ll-xceed-v2/utils/coaching/session-current-categories';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoachSessionsModel = CoachingCoachModel & {
  pendingConfirmation: CoachingSession[];
  actionRequired: CoachingSession[];
  actionRequiredCount: number;
};

export default class CoachingCoachSessionsRoute extends Route<CoachingCoachSessionsModel> {
  @service declare store: Store;
  @service declare session: SessionService;
  @service declare coachActionRequired: CoachActionRequiredService;

  async model(): Promise<CoachingCoachSessionsModel> {
    const coachModel = this.modelFor('coaching.coach') as CoachingCoachModel;
    const coachUserId = this.session.cached.userId!;

    const [pendingConfirmation, actionRequiredQuery] = await Promise.all([
      this.store.request(
        queryCoachingSessionsByCoach(
          coachUserId,
          COACH_PENDING_CONFIRMATION_KEYS
        )
      ),
      this.store.request(
        queryCoachingSessionsByCoach(
          coachUserId,
          COACH_ACTION_REQUIRED_QUERY_KEYS
        )
      ),
    ]);

    const pending = pendingConfirmation.content.data;
    const actionRequired = filterCoachActionRequired(
      actionRequiredQuery.content.data
    );

    // The nav badge counts the same thing this page does, so it is set from
    // what has just been fetched rather than querying again.
    this.coachActionRequired.setFromSessions(pending, actionRequired);

    return {
      ...coachModel,
      pendingConfirmation: pending,
      actionRequired,
      actionRequiredCount: pending.length + actionRequired.length,
    };
  }
}
